import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (result.success) {
      navigate("/dashboard");
    } else {
      toast.error(result.error, { id: "login-error" });
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0E14] text-white flex items-center justify-center px-6" data-testid="login-page">
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center space-y-1">
          <Link to="/" className="font-display font-black text-xl tracking-tight">SmartLinks</Link>
          <h1 className="text-2xl font-bold font-display pt-4">Welcome back</h1>
          <p className="text-sm text-slate-400">Log in to manage your link pages</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-white/5 border-white/15" data-testid="login-email-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="bg-white/5 border-white/15" data-testid="login-password-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-indigo-500 hover:bg-indigo-600 rounded-full h-11 font-bold" data-testid="login-submit-button">
            {loading ? "Logging in..." : "Log In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
